export default "__VITE_ASSET__P4t53zPk__"